var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-dialog', _vm._b({ attrs: { "visible": _vm.dialogVisible }, on: { "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      } } }, 'el-dialog', _vm.dialogAttrs, false), [_c('table-list', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.tableDialog.listLoading, expression: "tableDialog.listLoading" }], ref: "table", staticStyle: { "margin-top": "15px" }, attrs: { "list": _vm.tableDialog.tableListDialog, "columnConfig": _vm.tableDialog.tableColumnDialog } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };